<div
  *ngIf="isMeterActive"
  [ngClass]="{ sticky: isSticky }"
  class="progress-meter"
>
  <mat-progress-bar
    [color]="color"
    class="progress-meter__bar"
    mode="indeterminate"
  ></mat-progress-bar>
</div>
